<template>
  <Select :style="{ width: width + 'px' }" :max-tag-count="maxTagCount" :params="params" :placeholder="placeholder" clearable :transfer="transfer" :value="value" :disabled="disabled" :multiple="multiple" filterable @on-change="onChange">
    <Option v-for="item in dataList" :value="item[codeField]" :key="item[codeField]">{{ textFormatter ? textFormatter(item) : item[textField] }}</Option>
  </Select>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "onChange",
  },
  props: {
    width: {
      type: Number,
      default: 200,
    },
    value: String,
    placeholder: {
      type: String,
      default: "请选择",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: {},
    },
    url: String,
    codeField: {
      type: String,
      default: "id",
    },
    textField: {
      type: String,
      default: "name",
    },
    textFormatter: Function,
    filterRule: Function,
    transfer: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    maxTagCount: Number,
  },
  data() {
    return {
      dataList: [],
    };
  },
  mounted() {
    this.queryData();
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) == JSON.stringify(oldVal)) return;
        this.queryData();
      },
      //   deep: true
    },
  },
  methods: {
    queryData() {
      this.dataList = [];

      if (!this.url) throw new Error("url不能为空");

      let data = {
        url: this.url,
        body: this.params,
      };
      this.invoke(data).then((res) => {
        if (this.filterRule) res = res.filter(this.filterRule);

        this.dataList = res;
      });
    },

    onChange(val) {
      let checkedOption =
        this.dataList.find((item) => val == item[this.codeField]) || {};

      this.$emit("onItemChange", checkedOption);
      this.$emit("onChange", val);
    },
  },
};
</script>
